import { PassedInitialConfig } from 'angular-auth-oidc-client';

export const environment = {
  production: false,
  apiUrl: 'https://api-webconverter-dev.audaces.com/',
  url_audaces_id: 'https://login-dev.audaces.com',
  end_session_endpoint: 'https://login-dev.audaces.com/connect/endsession',
  post_logout_url: 'https://webconverter-homolog.audaces.com/login',
  audaces_id_key: 'audaces-web-converter_v2',
  callback_url: 'https://webconverter-homolog.audaces.com/login-callback',
  silent_renew_url:
    'https://webconverter-homolog.audaces.com/assets/silent-renew.html',
  scope: 'openid profile email offline_access',
  useSignalR: false,
  isSuperAdmin: false,
};

export const authOptions: PassedInitialConfig = {
  config: {
    authority: environment.url_audaces_id,
    clientId: environment.audaces_id_key,
    redirectUrl: environment.callback_url,
    scope: environment.scope,
    triggerAuthorizationResultEvent: true,
    responseType: 'code',
    postLogoutRedirectUri: environment.post_logout_url,
    silentRenew: true,
    silentRenewUrl: environment.silent_renew_url,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    startCheckSession: false,
    ignoreNonceAfterRefresh: true,
  },
};
